import template from './bookmarked_searches_edit.template.html?raw';
import 'angular';

angular
  .module('directives.bookmarkedSearchesEdit', [])
  .run(['$templateCache', function($templateCache) {
    $templateCache.put(template, template);
  }])
  .directive('bookmarkedSearchesEdit', function() {
    return {
      restrict: 'E',
      templateUrl: template,
      scope: false
    };
  });
